import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b836d97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "currentDate" }
const _hoisted_2 = { class: "liveDisplayTime" }

import { getCurrentDate } from '@/js/utils/date'
import { ref, onUnmounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveDisplayTime',
  setup(__props) {

const INTERVAL_TIME = 1000

const timeoutID = ref<number | null>(null)
const liveDisplayTime = ref<string>('')

onUnmounted(() => {
  if (timeoutID.value) {
    clearTimeout(timeoutID.value)
  }
})

/**
 * LIVE映像の表示日時(現在時間を表示)
 */
const setCurrentTime = () => {
  liveDisplayTime.value = getCurrentDate('YYYY/MM/DD HH:mm:ss')
  timeoutID.value = setTimeout(() => {
    setCurrentTime()
  }, INTERVAL_TIME)
}

setCurrentTime()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(liveDisplayTime.value), 1)
  ]))
}
}

})